import { useCallback } from 'react'

import { useRouter, useSearchParams } from 'next/navigation'

import { getNavigationUri } from '~/utils/devices'

export function useNavigation() {
  const router = useRouter()
  const searchParams = useSearchParams()

  const navigate = useCallback(
    (pathOrUrl: string, options?: { target?: 'tab' | 'window' }) => {
      if (options?.target === 'window') {
        window.open(
          getNavigationUri(searchParams, pathOrUrl),
          '_blank',
          'noopener,noreferrer,popup',
        )
        return
      }

      if (options?.target === 'tab') {
        window.open(getNavigationUri(searchParams, pathOrUrl), '_blank')
        return
      }

      router.push(getNavigationUri(searchParams, pathOrUrl))
    },
    [router, searchParams],
  )

  return navigate
}
